import { createReducer } from '@reduxjs/toolkit';
import { saveStorageObject, getCalculatorLocalStorage } from '@thd-olt-component-react/calculator';
import {
  addRoomSuccess,
  deleteMeasure,
  editMeasure,
  editedRow,
  saveEditSuccess,
  updateRoomPrice,
  updatePadPrice,
} from '../actions';
import { getInitialState } from '../store/defaultState';

const initial = getInitialState();

const updateLocalStorage = (currentMeasures) => {
  // when support for stairs is added by IX team we can uncomment this code.
  // const currentStorageObj =
  //   getCalculatorLocalStorage({ classInfo: { productDepartment: '23', classNumber: '15' } });
  // const { storageObj: { stairs = '' } } = currentStorageObj;
  const areas = currentMeasures.map((measure, ind) => {
    return {
      key: ind,
      calcByArea: false,
      name: measure.room,
      length: `${measure.length}`,
      width: `${measure.width}`,
      depth: '',
      squareFootage: `${measure.sqFt}`,
    };
  });
  saveStorageObject('PIP-23-15', { areas, addAdditionalCoverage: true /* , stairs */ });
  // DEBUG statement.  Delete on addition of stairs logic.
  // console.log(getCalculatorLocalStorage({ classInfo: { productDepartment: '23', classNumber: '15' } }));
};

export const measures = createReducer(initial,
  (builder) => builder
    .addCase(addRoomSuccess, (state, action) => {
      const newState = { ...state, measure: [...state.measure, action.payload] };
      updateLocalStorage(newState.measure);
      return (newState);
    })
    .addCase(deleteMeasure, (state, action) => {
      const newState = { ...state, measure: state.measure.filter((me) => me.id !== action.payload) };
      updateLocalStorage(newState.measure);
      return (newState);
    })
    .addCase(editMeasure, (state, action) => ({ ...state, isOpenOverlay: action.payload }))
    .addCase(editedRow, (state, action) => ({ ...state, currentEditedRow: action.payload }))
    .addCase(saveEditSuccess, (state, action) => {
      const newState = { ...state, measure: action.payload, isOpenOverlay: false };
      updateLocalStorage(newState.measure);
      return (newState);
    })
    .addCase(updateRoomPrice, (state, action) => {
      const newState =
        state.measure.map((measure) => (
          {
            ...measure,
            price: action.payload,
            squarePrice: (parseFloat(measure.sqFt / 9) * action.payload).toFixed(2)
          }));
      return ({ ...state, measure: [...newState] });
    })
    .addCase(updatePadPrice, (state, action) => {
      const pPrice = parseFloat(action?.payload);
      const newState = state.measure.map((measure) => (
        {
          ...measure,
          padPrice: pPrice,
          carpetPadPrice: parseFloat((measure.sqFt * action?.payload).toFixed(2)),
          totalPrice: parseFloat(((measure.sqFt * pPrice) + parseFloat(measure.squarePrice)).toFixed(2)),
        }));
      return { ...state, measure: newState };
    })
);